import jQuery from 'jquery';

//import("bootstrap/js/src/dropdown")


// diff views
if (jQuery("body.template-iterate_diff, body.template-history").length) {
  import("./compare.css");
}

if (jQuery("body.portaltype-plone-site, body.portaltype-lrf, body.template-folder_contents, body.template-edit").length) {
  import("bootstrap/js/src/dropdown")
}

/* Expose jQuery when needed */
window.jQuery = jQuery;
window.$ = jQuery;

// miscellaneous public js
import('./jquery.prettyPhoto');
import('./dkrz');
